module.exports = __webpack_public_path__ + "static/img/VIVO图标.4dd7b7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VIVO图标.jpg
// module id = ne4e
// module chunks = 1